export default "__VITE_ASSET__ByShgN1Y__"